import React from 'react';
import { FETCH_PARAMETRESFORM_FAILURE, FETCH_PARAMETRESFORM_REQUEST, FETCH_PARAMETRESFORM_SUCCESS } from '../Types';

const initialState = {PARAMETRESFORM:[], loadin:false, error:null};

const ListParametrageFormReducer = (state = initialState, action) => {
    switch (action.type) {
         case FETCH_PARAMETRESFORM_REQUEST:
            return {...state, loading:true, parametresForm:[], error:null};

        case FETCH_PARAMETRESFORM_SUCCESS:
            return {...state, loading:false, parametresForm: action.payload};
            
         case FETCH_PARAMETRESFORM_FAILURE:
            return {...state, loading:false, parametresForm:[], error: action.payload};
    
        default:
            return state;
    }

   
};

export default ListParametrageFormReducer;
